<template>
	<div class="account-saldo-page">

		<!-- MSISDN NUMBER INFO -->
		<div class="box-account-info">
			<table>
				<tr>
					<th>Número:</th>
					<td>
						{{ msisdn | msisdnToPhone }}
						<span v-if="isLoading" key="isLoading">
							<i class="fa fa-spin fa-cog"></i>
						</span>
					</td>
				</tr>
				<tr v-if="!!fetchedData">
					<th>IMEI:</th>
					<td>{{ fetchedData.responseSubscriber.information.IMEI }}</td>
				</tr>
			</table>
		</div>

		<!-- HR -->
		<hr>

		<!-- DIV -->
		<div v-if="!!msg">
			{{ msg | altanFixLabel}}
		</div>

		<!-- CONTENT TAB -->
		<div v-if="!!fetchedData" class="box-tab-1">

			<dn-progress-bar label="Minutos" v-if="!!fetchedData.personalized.minutes" :total="fetchedData.personalized.minutes.total" :used="fetchedData.personalized.minutes.used"  unit="Minutos"/>
				
			<dn-progress-bar label="SMS" v-if="!!fetchedData.personalized.sms" :total="fetchedData.personalized.sms.total" :used="fetchedData.personalized.sms.used" unit="SMS"/>
				
			<dn-progress-bar label="Datos" v-if="!!fetchedData.personalized.data" :total="fetchedData.personalized.data.total" :used="fetchedData.personalized.data.used">
				<div slot="reference">
					{{fetchedData.personalized.data.used | mb2gb}} / {{fetchedData.personalized.data.total | mb2gb}}
				</div>
			</dn-progress-bar>
				
			<dn-progress-bar label="Velocidad reducida" v-if="!!fetchedData.personalized.reduced" :total="fetchedData.personalized.reduced.total" :used="fetchedData.personalized.reduced.used">
				<div slot="reference">
					{{fetchedData.personalized.reduced.used | mb2gb}} / {{fetchedData.personalized.reduced.total | mb2gb}}
				</div>
			</dn-progress-bar>

			<msisdn-recharge-history class="mt-2" :charge-history="chargeHistory" :calls-history="callsHistory" :msisdn="msisdn"/>

		</div>

	</div>
</template>

<script>
import mobiscroll from '@mobiscroll/javascript'
import DnProgressBar from '../daniel/dn-progress-bar.vue'
import MsisdnRechargeHistory from '../daniel/msisdnRechargeHistory.vue'

export default {
	name: 'accountSaldoPage',
	components: { DnProgressBar, MsisdnRechargeHistory },
	props: {
		msisdn: {
			type: [String, Number],
			required: true
		}
	},
	data: () => {
		return {
			isLoading: false,
			isValid: null,
			msg: null,
			fetchedData: null,
			chargeHistory: [],
			callsHistory: []
		}
	},
	methods: {
		async loadUp() {
			try {
				let response = await axios.get('skyaccount/msisdncheckadvance/' + this.msisdn)

				this.msg = response.msg
				this.isValid = (!!response.status)

				if(!response.status)
					throw 'Error en la consulta';

				if (this.isValid) {
					this.fetchedData = response.data
				}

				this.chargeHistory = response.historial
				this.callsHistory = response.historial_llamadas

				return true;
			} catch (e) {
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				console.error(e)
			}
		}
	},
	async mounted() {
		this.isLoading = true
		await this.loadUp()
		this.isLoading = false
	}
}
</script>

<style lang="less">
.account-saldo-page {
	&+.account-saldo-page {
		margin-top: 3em;
	}

	.box-tab-1 .box-bar .col-title {
		text-align: left;
		margin-left: 12.5em;
	}

}
</style>